export const LOAD_ORGANIZATIONS="LOAD_ORGANIZATIONS";
export const TOGGLE_ORG_POPUP="TOGGLE_ORG_POPUP";
